<template>
<CRow>

 <CCol sm="6" md="6">
  <CCard>
    <CCardHeader>
      <CIcon name="cil-justify-center"/>
      <strong>Envoi d'un message</strong>
    </CCardHeader>
    <CCardBody> 
      <CRow>    
        {{Responses}}
      </CRow>                      
    </CCardBody>
  </CCard>
</CCol>
</CRow>
</template>

<script>

const APIURL = process.env.VUE_APP_API_URL
import axios from 'axios'

function numHex(s)
{
    var a = s.toString(16);
    if ((a.length % 2) > 0) {
        a = "0" + a;
    }
    return a;
}

function strHex(s)
{
    var a = "";
    for (var i=0; i<s.length; i++) {
        a = a + numHex(s.charCodeAt(i));
    }

    return a;
}


export default {

  name: 'SNEmitRB',
  props: {  
    items: Array,
    fields: {
      type: Array,
      default () {
        return [ 
        { key: 'time',             label: 'dateAndTime', _style: 'width:160px;' },
        //{ key: 'status',           label: 'status', _style: 'width:30px;' },        
        { key: 'provider',         label: 'provider', _style: 'width:30px;' },
        { key: 'serial',           label: 'serial', _style: 'width:30px;' },
        { key: 'imei',             label: 'imei', _style: 'width:30px;' },
        { key: 'msgType',          label: 'msgType', _style: 'width:30px;' },
        { key: 'payload',          label: 'Payload', _style: 'min-width:40px; max-width:100px;' }, 
        { key: 'payloadLen',       label: 'payloadLen', _style: 'width:30px;' }
        ]
      }
    },
    caption: {
      type: String,  
      default: 'SNEmitRB'
    },
    clickableRows: Boolean ,
    hover: Boolean,
    striped: Boolean, 
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() 
  {
    return {
      message: "",
      ddSelection: " Choisir le # de Serie",
      ddSelectionIMEI: "",
      Responses: ""
    }
  }, 
  created()
  { 
        var ROCKBLOCK_API_SEND='https://core.rock7.com/rockblock/MT'
        var ROCKBLOCK_USERNAME='stremblay@quantiumsys.com'
        var ROCKBLOCK_PASSWORD='katana07'

        fetch('https://core.rock7.com/rockblock/MT?imei=300234065890890&username=stremblay@quantiumsys.com&password=katana07&data=31',
          {
            method: 'POST',
            mode: 'no-cors', 
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'text/plain',
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: strHex( 'ZZ' )
          } )
    /*    .then(res =>{
          console.log( res )
           res.json() })  */
        .then( async  response => {
              console.log(response)
              /*console.log(response.json())
              console.log(response.text)*/
            const data =  await response.text()
            console.log(data)

              if (response.ok)
              {
              console.log(data)
                console.log("response ok = VRAI! "+response)
                this.Responses= "OK"
                const res2 =  axios.post(
                    APIURL+'/api1/messages',              
                      { 
                        imei: '300234065890890', // this.ddSelectionIMEI,
                        provider: "rockblock",
                        status:0,
                        msgSequence: 0,
                        approxLat: 0.0,
                        approxLong: 0.0,
                        msgType:0,              
                        direction: "MT",
                        payload: '31',
                        payloadLen: 2,
                        creditUsed: 0
                      },
                      {   
                        mode: 'no-cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                          },
                      withCredentials: false
                      }
                  )
              }
              else
              {
                 console.log("response ok = FAUX! "+response)
                 this.Responses= "Rockblock API Error: response status="+response.ok
              }
        })
        .catch(error =>  {
          console.error(error)
          this.Responses=  error
        });
  }  
} 
</script>
